import { render, staticRenderFns } from "./ChallengesSituationsTemplate.vue?vue&type=template&id=495b8254&scoped=true"
import script from "./ChallengesSituationsTemplate.vue?vue&type=script&lang=ts"
export * from "./ChallengesSituationsTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b8254",
  null
  
)

export default component.exports